import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup, Validators,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        ScreenMessageHandler,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS003SiharaiEntryOutVO,} from '@pages/sms003-siharai-entry/sms003-siharai-entry-out-vo';
import {SMS003SiharaiEntryDispVO,} from '@pages/sms003-siharai-entry/sms003-siharai-entry-disp-vo';
import * as Const_SMS003 from '@pages/sms003-siharai-entry/sms003-siharai-entry-const';
import {SMS008KingakuInfoInVO,} from '@pages/sms008-kingaku-info/sms008-kingaku-info-in-vo';
import {isEmpty,} from 'lodash';
import {Title,} from '@angular/platform-browser';
import * as moment from 'moment';

@Component({
  selector: 'app-sms003-siharai-entry',
  templateUrl: './sms003-siharai-entry.html',
  styleUrls: ['./sms003-siharai-entry.scss',],
})
/*****************************************************/
/* 処　理：SMS003 現在残高・支払希望日 画面
/*
/* 概　要：現在残高・支払希望日確認 処理
/*
/* 更新日：2025/03/05 HARAGU 00011_SMS機能等の導入支援_#10074
/*****************************************************/
export class SMS003SiharaiEntry implements OnInit {
  smsForm!: FormGroup;                      // 画面フォーム
  loginUserVO!: LoginUserVO;                // セッション情報
  sms003ApiRetVO!: SMS003SiharaiEntryOutVO; // API返却情報
  dispId!: string;                          // ログ表示用ID
  lngType!: string;                         //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // ボタン操作可否
  isEnableBtnDetail = true;
  isEnableBtnSend = true;
  isEnableBtnMenu = true;

  // 画面項目（ラベル入れ替え用）
  public lblName!: string;
  public lblGokei!: string;
  public lblGokeiGaku!: string;
  public lblYakusokuDateMM!: string;
  public lblYakusokuDateDD!: string;
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblMessage04!: string;
  public lblMessage05!: string;
  public lblMessage06!: string;
  public lblMessage07!: string;
  public lblBtnDetail!: string;
  public lblBtnSend!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  // 明細表示用クラス
  initVo: SMS003SiharaiEntryDispVO[] = [];

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private screenMessage: ScreenMessageHandler,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00301M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
      rdoYatinYmKbn: ['',],
      txtYakusokuDateMM: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(2),
          this.validationService.numericFromToValidator(1, 12),
        ],
      ],
      txtYakusokuDateDD: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(2),
          this.validationService.numericFromToValidator(1, 20),
        ],
      ],
    });

    // 初期表示
    this.formInit();
  }


  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00301M001I', this.dispId, Const_SMS003.INIT_NAME);

      // 初期表示API処理
      this.getInitData(Const_SMS003.API_INIT_PATH, Const_SMS003.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00301M002I', this.dispId, Const_SMS003.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00301M001E', this.dispId, Const_SMS003.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 03 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 03 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 03 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 03 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00301M003I', this.dispId, btnName);
    this.httpClient.post<SMS003SiharaiEntryOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00301M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00301M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
          return;
        }
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00301M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 03 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS003SiharaiEntryOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS003SiharaiEntryOutVO): void {

    this.logger.debug(this.dispId + ' ■ 03 start-- getInitApiReturnInfo');

    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 03 ApiOut  yakusokuDate ：' + resp['yakusokuDate']);
    this.logger.debug(this.dispId + ' ■ 03 ApiOut  goukeiGaku   ：' + resp['goukeiGaku']);

    // 入金約束存在フラグ(初期値 0：入金約束なし)
    let isDepositPromiseFlg = false;

    // 現在日付を取得
    const  today = new Date();

    // 約束日が設定されていた場合
    if (!isEmpty(resp['yakusokuDate'])) {

      // 翌日日付を取得
      const nextDay = new Date(today);
      nextDay.setDate(today.getDate() + 1);
      // 翌日日付の次の月の1日を取得
      const monthLastDay = new Date(nextDay.getFullYear(), (nextDay.getMonth() + 1) , 1);
      // 1日減算して、翌日日付の月末日を取得
      monthLastDay.setDate(monthLastDay.getDate() - 1);

      // 約束日を取得
      const yakusokuDay = new Date( Number(resp['yakusokuDate'].substring(0, 4)),
                                   (Number(resp['yakusokuDate'].substring(4, 6)) - 1),
                                    Number(resp['yakusokuDate'].substring(6, 8)));

      this.logger.debug(this.dispId + ' ■ 03 当日日付 ：' + moment(today).format('YYYYMMDD'));
      this.logger.debug(this.dispId + ' ■ 03 翌日日付 ：' + moment(nextDay).format('YYYYMMDD'));
      this.logger.debug(this.dispId + ' ■ 03 月末日付 ：' + moment(monthLastDay).format('YYYYMMDD'));
      this.logger.debug(this.dispId + ' ■ 03 約束日付 ：' + moment(yakusokuDay).format('YYYYMMDD'));

      // ------------------------------------------
      // 入金約束フラグの判定
      // ------------------------------------------
      // 実行時日付 + 1 ＜ 変数.最新約束日 ＜ 実行時日付 + 1 の月末日の場合
      //   1：入金約束あり
      // 上記以外の場合
      //   0：入金約束なし
      // ------------------------------------------

      // 実行時日付 + 1 <= 変数.最新約束日
      if (moment(nextDay).format('YYYYMMDD') <= moment(yakusokuDay).format('YYYYMMDD') ) {
        // 変数.最新約束日 <= (実行時日付 + 1) の月末日
        if (moment(yakusokuDay).format('YYYYMMDD') <= moment(monthLastDay).format('YYYYMMDD') ) {
          // 1:入金約束あり
          isDepositPromiseFlg = true;
        }
      }
    }

    this.logger.debug(this.dispId + ' ■ 03 入金約束フラグ ：' + isDepositPromiseFlg);

    // 支払明細
    const retVOList: SMS003SiharaiEntryDispVO[] = resp['siharaiVO'];

    // 画面文言（言語区分により変換）
    // {0}　{1} 様
    this.lblName = (this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M001F',},  false) || '').replace('{1}', resp['sei']).replace('{2}', resp['mei']);
    // オリコフォレントインシュアでございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M002F',},  false) || '';

    if (isDepositPromiseFlg) {
      // 「1：入金約束あり」

      // 以下の内容でお支払約束が登録されております。
      this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M004F',},  false) || '';

      // テキストボックス設定
      this.smsForm.get('txtYakusokuDateMM')?.setValue(resp['yakusokuDate'].substring(4, 6));
      this.smsForm.get('txtYakusokuDateDD')?.setValue(resp['yakusokuDate'].substring(6, 8));

      // 支払日、送信ボタン非活性
      this.smsForm.controls['txtYakusokuDateMM'].disable();
      this.smsForm.controls['txtYakusokuDateDD'].disable();
      this.isEnableBtnSend = false;

    } else {
      // 「0：入金約束なし」の場合

      // 未納金額は以下となります。
      this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M003F',},  false) || '';

      // テキストボックス設定
      this.smsForm.get('txtYakusokuDateMM')?.setValue('');
      this.smsForm.get('txtYakusokuDateDD')?.setValue('');

      // 当日日付(日)を取得
      const todayDD = today.getDate();

      // 当月20日までしか入力できない
      if (todayDD > Const_SMS003.INPUT_LIMIT_DAY) {
        // 支払日、送信ボタン非活性
        this.smsForm.controls['txtYakusokuDateMM'].disable();
        this.smsForm.controls['txtYakusokuDateDD'].disable();
        this.isEnableBtnSend = false;
      } else {
        // 支払日、送信ボタン活性
        this.smsForm.controls['txtYakusokuDateMM'].enable();
        this.smsForm.controls['txtYakusokuDateDD'].enable();
        this.isEnableBtnSend = true;
      }
    }


    // {0}年{1}月
    const ym = (this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M005F',},  false) || '');
    // {1} 円
    const yen = (this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M007F',},  false) || '');

    // 明細情報 設定
    for (const retVO of retVOList) {

      // ログ出力（API出力情報）
      this.logger.debug(this.dispId + ' ■ 03 ApiOut  yatinYm      ：' + retVO.yatinYm);
      this.logger.debug(this.dispId + ' ■ 03 ApiOut  seikyuGaku   ：' + retVO.seikyuGaku);

      const yy = retVO.yatinYm.substring(0, 4);
      const mm = retVO.yatinYm.substring(4, 6);
      this.initVo.push({id: retVO.yatinYm
                      , yatinYm: ym.replace('{1}', yy).replace('{2}', mm)
                      , seikyuGaku: yen.replace('{1}', retVO.seikyuGaku),});
    }

    // 合計額
    this.lblGokei = (this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M006F',},  false) || '');
    this.lblGokeiGaku = yen.replace('{1}', resp['goukeiGaku']);

    if (isDepositPromiseFlg) {
      // 【支払日】
      this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M009F',},  false) || '';
    } else {
      // 【支払希望日】
      this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M008F',},  false) || '';
    }

    // MM
    this.lblYakusokuDateMM = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M010F',},  false) || '';
    // 月
    this.lblMessage04 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M011F',},  false) || '';
    // DD
    this.lblYakusokuDateDD = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M012F',},  false) || '';
    // 日
    this.lblMessage05 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M013F',},  false) || '';
    // 当月21日以降の支払日登録はできませんのでお電話ください。
    this.lblMessage06 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M014F',},  false) || '';
    // 一括でのお支払いが難しい場合は、当社までお電話ください。
    this.lblMessage07 = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M015F',},  false) || '';
    // 詳細金額表示へ
    this.lblBtnDetail = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M016F',},  false) || '';
    // 送信
    this.lblBtnSend = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M017F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M018F',},  false) || '';

    // 家賃年月のデフォルト値設定
    this.smsForm.get('rdoYatinYmKbn')?.setValue(this.initVo[0].id);
    this.logger.debug(this.dispId + ' ■ 03 default rdoYatinYmKbn ：' + this.smsForm.get('rdoYatinYmKbn')?.value);

    // ブラウザタイトル・ヘッダータイトル
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    let screenName = ''
    if (isDepositPromiseFlg) {
      screenName = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M002T',}) || '';
    } else {
      screenName = this.messageProvider.getMessageString({messageId: 'SMS003' + this.lngType + 'M001T',}) || '';
    }
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 03 end---- getInitApiReturnInfo');
    return;
  }

  /* **************************************************************
   * 詳細金額表示へボタン
   * **************************************************************/
  detailClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00301M005I', this.dispId, Const_SMS003.BTN_DETAIL_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック（詳細金額表示）
      if (!this.inputCheckDetail()) {
        return;
      }

      // 画面遷移
      this.nextPage('SMS008');

    } catch (ex) {
      this.logger.error('SMS00301M002E', this.dispId, Const_SMS003.BTN_DETAIL_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック（詳細金額表示）
   * @returns true/false
   */
  inputCheckDetail(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 03 入力チェック開始（詳細金額表示）');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 家賃年月
    if (this.smsForm.get('rdoYatinYmKbn')?.value === '') {
      this.logger.debug('■ 03 家賃年月：必須NG');
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 03 入力チェック終了（詳細金額表示）');

    return isRet;
  }

  /* **************************************************************
   * 送信ボタン
   * **************************************************************/
  executeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00301M005I', this.dispId, Const_SMS003.BTN_EXECUTE_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック（送信）
      if (!this.inputCheckExecute()) {
        return;
      }

      // 画面項目制御
      this.enabledChange(false);

      // 支払約束日登録API処理 呼出
      this.doEexecute(Const_SMS003.API_EXECUTE_PATH, Const_SMS003.BTN_EXECUTE_NAME);

    } catch (ex) {
      this.logger.error('SMS00301M002E', this.dispId, Const_SMS003.BTN_EXECUTE_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック（送信）
   * @returns true/false
   */
  inputCheckExecute(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 03 入力チェック開始（送信）');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 支払日(月)
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtYakusokuDateMM.value)) {
      this.logger.debug('■ 03 支払日(月)：必須NG');
      this.smsForm.controls.txtYakusokuDateMM.setErrors({required: true,});
      this.smsForm.controls.txtYakusokuDateMM.markAsDirty();
      isRet = false;
    }
    // 支払日(日)
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtYakusokuDateDD.value)) {
      this.logger.debug('■ 03 支払日(日)：必須NG');
      this.smsForm.controls.txtYakusokuDateDD.setErrors({required: true,});
      this.smsForm.controls.txtYakusokuDateDD.markAsDirty();
      isRet = false;
    }

    // 現在日付を取得
    const today = new Date();
    const todayYYYY = today.getFullYear();
    const todayMM = ('00' + (today.getMonth() + 1)).slice(-2);
    const todayDD = ('00' + today.getDate()).slice(-2);

    const todayDate = todayYYYY + todayMM + todayDD;
    this.logger.debug(this.dispId + ' ■ 03 todayDate   ：' + todayDate);

    // 現在日付の年＋入力された月・日で、支払日を取得
    const yakusokuDate = todayYYYY + this.smsForm.controls.txtYakusokuDateMM.value + this.smsForm.controls.txtYakusokuDateDD.value;
    this.logger.debug(this.dispId + ' ■ 03 yakusokuDate：' + yakusokuDate);
    // 当月20日の年月日を取得
    const limiteDate = todayYYYY + todayMM + Const_SMS003.INPUT_LIMIT_DAY;
    this.logger.debug(this.dispId + ' ■ 03 limiteDate  ：' + limiteDate);

    // ------------------------------------------
    // 日付型の整合性チェック
    // ------------------------------------------
    if (!this.validationService.isDateYYYYMMDD(yakusokuDate)) {
      this.logger.debug('■ 03 支払日：isDateYYYYMMDD NG');
      isRet = false;
    }
    // ------------------------------------------
    // 妥当性チェック
    // ・翌日以降の日付になっていること
    // ・当月20日のより先の日付を入力できない
    // （例：支払希望日に12月21日以降の入力不可）
    // ------------------------------------------
    if (todayDate >= yakusokuDate) {
      this.logger.debug('■ 03 支払日：妥当性(翌日以降の日付) NG');
      isRet = false;
    }
    if (yakusokuDate > limiteDate) {
      this.logger.debug('■ 03 支払日：妥当性(当月20日まで) NG');
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 03 入力チェック終了（送信）');

    return isRet;
  }

  /**
   * 支払約束日登録API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private doEexecute(path: string, btnName: string): void {

    // ログ出力
    this.logger.info('SMS00301M001I', this.dispId, btnName);
    this.logger.debug(this.dispId + ' ■ 03 start-- doEexecute');

    const today = new Date();
    const todayYYYY = today.getFullYear();
    const yakusokuDate = todayYYYY + this.smsForm.controls.txtYakusokuDateMM.value + this.smsForm.controls.txtYakusokuDateDD.value;

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
      yakusokuDate:  yakusokuDate,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 03 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 03 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 03 ApiIn   shouninNo    ：' + apiVo.shouninNo);
    this.logger.debug(this.dispId + ' ■ 03 ApiIn   yakusokuDate ：' + apiVo.yakusokuDate);

    // 支払約束日登録API
    this.logger.info('SMS00301M003I', this.dispId, btnName);
    this.httpClient.post<SMS003SiharaiEntryOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00301M004I', this.dispId, btnName);
        if (resp != null) {
          // 手続き完了画面に遷移
          this.nextPage('SMS010');

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00301M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        this.logger.error('SMS00301M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 03 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 画面遷移処理
   * @param {string} dispId 画面ID
   */
  nextPage(dispId: string): void{
    if ('SMS008' === dispId) {
      this.logger.debug(this.dispId + ' ■ 03 → 08 画面遷移');
      const info008Vo: SMS008KingakuInfoInVO = new SMS008KingakuInfoInVO();
      info008Vo.yatinYm = this.smsForm.get('rdoYatinYmKbn')?.value;
      this.windowService.transit<SMS008KingakuInfoInVO>('SMS008', info008Vo);

    } else {
      this.logger.debug(this.dispId + ' ■ 03 → 10 画面遷移');
      this.windowService.transit<null>('SMS010', null);
    }
  }


  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00301M005I', this.dispId, Const_SMS003.BTN_BACKMENU_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00301M002E', this.dispId, Const_SMS003.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }


  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 03 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

  /**
   * 画面項目の制御
   * @param {boolean} isEnabledFlg
   */
  enabledChange(isEnabledFlg: boolean): void {
    this.isEnableBtnDetail = isEnabledFlg;
    this.isEnableBtnSend = isEnabledFlg;
    this.isEnableBtnMenu = isEnabledFlg;
  }

}
